import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {getFTPExportLogs, getFTPI_ExportLogsDashboard, getFTPI_ImportLogsDashboard, getFTPImportLogs, getOrganogramLogs, getOrganogramStatus, getOrganogramTypes, resetFTPExport, resetImportLogd, resetOrganogramLog,}  from  './FTPRepo'
import { toast } from "react-toastify";

// fetching all FTP imports Logs

interface DashBoardParams {
    enable?: boolean;   
    params: {
      pageInteger: number,
      limitInteger:number,
      search:string
      };
}


export const useGetFTPImportLogsDashBoard = ({enable = false,params}:DashBoardParams)=>{
    return useQuery({
        queryKey:['GET_FTP_IMPORT_LOGS',params],
        queryFn:()=>getFTPI_ImportLogsDashboard(params),
        retry:false,
        enabled:enable,
    })
}


export const useGetFTPExportLogsDashBoard = ({enable = false,params}:DashBoardParams)=>{
    return useQuery({
        queryKey:['GET_FTP_EXPORT_LOGS',params],
        queryFn:()=>getFTPI_ExportLogsDashboard(params),
        retry:false,
        enabled:enable,
    })
}



interface UseFTPImportLogsProps {
    enable?: boolean;
    params:{
        page?: number;
        limit?: number;
        search?: string;
        sortOrder?: 'ASC' | 'DESC';
        sortColumn?: string;
        // monthYear?: string;
    }
}



export const useGetFTPImportLogs = ({enable = false,params}:UseFTPImportLogsProps)=>{
  return useQuery({
       queryKey:['GET_FTP_LOGS',params],
       queryFn:()=>getFTPImportLogs(params),
       retry:false,
       enabled:enable,
    }
  )
}




interface UseFTPExportLogsProp {
    enable?:boolean;

    params?:{
      page?:number;
      limit?:number,
      search?:string;
      sortOrder?:'ASC | DSC',
      sortColumn?:string;
      monthYear?:string
    }

}

export const useGetFTPExportLogs = ({enable = false,params}:UseFTPExportLogsProp)=>{
    return  useQuery({
         queryKey:['GET_FTP_EXPORT_LOGS',params],
         queryFn:()=>getFTPExportLogs(params),
         enabled:enable,
         retry:false
    })
}

export const useGetOrganogramTypes = ({enable= false}:{enable:boolean})=>{
  return useQuery({
      queryKey:['GET_ORGANOGRAM_TYPES'],
      queryFn:getOrganogramTypes,
      retry:false,
      enabled:enable
  })
}

export const useGetOrganogramStatus=({enable=false}:{enable:boolean})=>{
    return useQuery({
      queryKey:['GET_ORGANOGRAM_STATUS'],
      queryFn:getOrganogramStatus,
      retry:false,
      enabled:enable
    })
}




interface OrganogramLogsProp {
   enable?:boolean;

   params?:{

   page?:number;
   limit?:number;
   search?:string;
   status?:string;
   actionType?:string;
   requestedData?:string;
   filePath?:string;
   sortOrder?:'ASC | DSC',
   sortColumn?:string;
   }
}

export const useGetOrganogramLogs =({enable = false,params}:OrganogramLogsProp)=>{
    return useQuery({
        queryKey:['GET_ORGANOGRAM_LOGS',params],
        queryFn:()=>getOrganogramLogs(params)
    })
}


export const useResetFTPExport = () => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: (id: number) => resetFTPExport(id),
      onSuccess: () => {
        toast.success('Reset Successfully!', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
  
        queryClient.invalidateQueries({ queryKey: ['GET_FTP_EXPORT_LOGS'] });
      },
      onError: (error: any) => {
        console.error('Failed to Reset:', error.message);
        toast.error('Failed to reset. Please try again');
      },
      retry: false,
    });
  };


  export const useResetOrganogramLog =()=>{
        
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn:(id:number)=>resetOrganogramLog(id),
        onSuccess:()=>{
        toast.success('Reset Succssfully!',{
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        queryClient.invalidateQueries({queryKey:'GET_ORGANOGRAM_LOGS'});
       },
       onError:(error)=>{
            console.log('Failed to reset',error.message);
            toast.error('Failed to rest Please try again');
       }  
      })
  }

export const useResetFTPImport = ()=>{
  const queryClient  = useQueryClient();

 return useMutation({
        mutationFn:(id:number)=>resetImportLogd(id),
        onSuccess:()=>{
          toast.success('Reset Succssfully!',{
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          queryClient.invalidateQueries({queryKey:'GET_FTP_LOGS_DASHBOARD'})

        },

        onError:(error)=>{
        console.log('Failed to reset',error.message);
        toast.error('Failed to reset Please try agian');
        }
  })
}